import script from "./LastInteractionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LastInteractionModal.vue?vue&type=script&setup=true&lang=ts"

import "./LastInteractionModal.vue?vue&type=style&index=0&id=762fa9b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762fa9b1"]])

export default __exports__